/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class ScreenControllerTypes {
    static ERROR_SCREEN = 'ERROR_SCREEN';

    static GUIDE = 'GUIDE';

    static SETTINGS_SCREEN = 'SETTINGS_SCREEN';

    static SIGN_IN_SCREEN = 'SIGN_IN_SCREEN';

    static SOS_SCREEN = 'SOS_SCREEN';

    static SPLASH_SCREEN = 'SPLASH_SCREEN';

    static VIDEO_PLAYER = 'VIDEO_PLAYER';

    static ANTIBURN_SCREEN = 'ANTIBURN_SCREEN';
}
